// src/slices/myProfile/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getAuthToken } from "../../../utils/auth";
import { handleApiError } from "../../handleApiError";

const API_URL = process.env.REACT_APP_API_URL;

// 🔹 Get Profile
export const getMyProfile = createAsyncThunk(
  "profile/getMyProfile",
  async (_, { rejectWithValue }) => {
    try {
      const token = getAuthToken();

      if (!token) {
        return rejectWithValue("NO_TOKEN");
      }

      const response = await axios.get(`${API_URL}/user/myProfile`, {
        headers: {
          Authorization: token,
        },
      });

      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        return rejectWithValue("TOKEN_EXPIRED");
      }

      return rejectWithValue("Failed to load profile");
    }
  },
);

// 🔹 Update Profile
export const updateMyProfile = createAsyncThunk(
  "profile/updateMyProfile",
  async (profileData, { rejectWithValue }) => {
    try {
      const token = getAuthToken();

      const response = await axios.put(
        `${API_URL}/user/myProfile`,
        profileData,
        {
          headers: {
            Authorization: `${token}`,
          },
        },
      );
      // console.log(response);
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(
        error?.response?.data?.error?.message || "Failed to update profile",
      );
    }
  },
);
